// Report 4.0 is the same as Report 5.0 but with legacy mode enabled certain places.

import Report_4_0_PDF from '../report_5_0/report_5_0.js';
export default Report_4_0_PDF;
